import React, { useContext, useState } from "react";
import { Controls } from "./Controls";
import { FeatureInfoContext } from "./FeatureInfoContext";

export const Sidebar = (): JSX.Element => {
    const { helpLayer, cadastralLayers } = useContext(FeatureInfoContext);
    const [CurrentTab, setCurrentTab] = useState(0);
    const [LeftPanelOpen, setLeftPanelOpen] = useState(false);

    /**
     * Opens/closes the tabs in the sidebar
     * @param event event
     * @param index Index of the tab that is clicked
     */
    const toggleTab = (event, index) => {
        event.preventDefault();

        /**
         * If current tab is reclicked, closesidebar
         * Else open new tab
         */
        if (CurrentTab === index) {
            closeSidebar();
        } else {
            setCurrentTab(index);
            if (!LeftPanelOpen) {
                setLeftPanelOpen(true)
            }
        }
    };

    /**
     * Closes sidebar
     */
    const closeSidebar = () => {
        setLeftPanelOpen(false);
        setCurrentTab(0);
    };

    /**
     * Handler for slider 
     */
    const sliderChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target) return;

        // Slider information
        const sliderName = e.target.name;
        const value = e.target.value as unknown as number;

        // Get correct layer and set opacity
        if (sliderName !== "hulpkaart") {
            const layer = cadastralLayers.filter(layer => layer.get("name") === sliderName)[0];
            layer.setOpacity(Number(value / 100));
        } else {
            helpLayer.setOpacity(Number(value / 100));
        }

    };

    /**
     * Get active class
     * @param index Index of the clicked tab
     * @param className "Active" classname 
     * @returns 
     */
    const getActiveClass = (index, className) => (CurrentTab === index ? className : "");

    return (
        <div className={LeftPanelOpen ? "leftpanel" : "leftpanel collapsed"}>
            <div className="sidebar sidebar-left">
                <div className="sidebar-tabs">
                    <ul role="tablist">
                        <li className={`tabs ${getActiveClass(1, "active")}`}>
                            <a href="#home" role="tab" onClick={(e) => toggleTab(e, 1)}>
                                <i className="fa fa-bars"></i>
                            </a>
                        </li>
                        <li className={`tabs ${getActiveClass(3, "active")}`}>
                            <a href="#3" role="tab" onClick={(e) => toggleTab(e, 3)}>
                                <i className="fa fa-sliders"></i>
                            </a>
                        </li>
                        <li className={`tabs ${getActiveClass(5, "active")}`}>
                            <a href="#5" role="tab" onClick={(e) => toggleTab(e, 5)}>
                                <i className="fa fa-info"></i>
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="sidebar-content">
                    {/* <!-- Home tab --> */}
                    <div className={`sidebar-pane noselect ${getActiveClass(1, "active")}`} id="home">
                        <h1 className="sidebar-header">
                            Kadastrale Kaart Avereest
                            <span className="sidebar-close" onClick={() => closeSidebar()}>
                                <i className="fa fa-caret-left"></i>
                            </span>
                        </h1>

                        <p>
                            <b>Basis kaarten</b>
                        </p>
                        <p className="lorem">
                            Op de huidige topografische kaart{" "}
                            <a href="https://www.kadaster.nl/brt" target="_blank">
                                BRT-A
                            </a>{" "}
                            (Achtergrond) als basis kaart kunnen de verschillende historische kadastrale kaarten getoond
                            worden. Ook kan gekozen worden voor een actuele <b>luchtfoto</b>. Als alternatief is er de
                            OpenStreetMap{" "}
                            <a href="https://www.openstreetmap.org/" target="_blank">
                                OSM
                            </a>{" "}
                            basiskaart.
                        </p>
                        <b>Kadaster kaarten</b>
                        <p className="lorem">
                            Op dit moment zijn er drie volledige kaarten beschikbaar. Deze geven de situatie weer van de
                            dienstjaren 1832, 1862 en 1888. Wijzigingen in de tussenliggende jaren zijn vastgelegd op
                            z.g. hulpkaarten. Ook deze zijn, beperkt, beschikaar, nu van sectie A t/m E voor de jaren
                            1832 tot 1862 en secties L en H van 1863 t/m 1966.
                            <br />
                            In de Basisregistratie Kadaster (
                            <a href="https://www.kadaster.nl/brk" target="_blank">
                                BRK
                            </a>
                            ) wordt de actuele toestand van de kadastrale kaart bijgehouden. Deze kan ook als laag
                            getoond worden, daartoe moet wel ver ingezoomt worden !.
                            <br />
                            Met het horizontale schuifje kan de transparantie van de kaartlagen verandert worden.
                        </p>
                        <b>Percelen</b>
                        <p className="lorem">
                            De kadastrale percelen worden weergegen door punten met het perceelnummer. Dit nummer
                            bestaat uit een unieke combinatie van een sectieletter en een volgnummer. b.v. <b>a123</b>.
                            <br />
                            <br />
                            Met de zoek knop kan een percel gezocht worden door het intoetsen van de sectie en nummer
                            combinatie. Er wordt dan een z.g. marker op de kaart geplaatst.
                            <br />
                            <br />
                            Door het selecteren (klik) van het perceelpunt kan de legger informatie en de filiatie van
                            het perceel bekeken worden.
                        </p>
                        <b>Legger en Filiatie</b>
                        <p className="lorem">
                            Voor het tonen van de administratieve gegevens van een perceel en de bijbehorende filiatie
                            wordt gekoppeld naar de site van{" "}
                            <a href="http://www.bonmama.nl/avkad.php" target="_blank">
                                bonmama.nl
                            </a>{" "}
                            waar een schat aan informatie te vinden is.
                        </p>

                        <b>Dienstjaar</b>
                        <p className="lorem">
                            Alle jaartallen hier zijn dienstjaren. Het dienstjaar was gemiddeld &#233;&#233;n jaar later dan het
                            kalenderjaar.
                        </p>
                    </div>
                    {/* <!-- Transparantie tab --> */}
                    <div className={`sidebar-pane noselect ${getActiveClass(3, "active")}`} id="Transparantie">
                        <h1 className="sidebar-header">
                            Transparantie
                            <span className="sidebar-close" onClick={() => closeSidebar()}>
                                <i className="fa fa-caret-left"></i>
                            </span>
                        </h1>
                        <p>Verander de transparantie van de diverse kaartlagen onderling.</p>
                        {cadastralLayers.map((layer, index) => {
                            return (
                                <p>
                                    {layer.get("name")}
                                    <input type="range" id={`slider${index}`} className="slider" min="0" max="100" defaultValue={100} name={layer.get("name")} onChange={sliderChangeHandler} />
                                </p>
                            )
                        })}
                        <p>
                            {"hulpkaart"}
                            <input type="range" id={"slider-hulpkaart"} className="slider" min="0" max="100" defaultValue={helpLayer.getVisible() ? "100" : "0"} name={"hulpkaart"} onChange={sliderChangeHandler} />
                        </p>
                    </div>
                    {/* <!-- Informatie venster tab --> */}
                    <div className={`sidebar-pane noselect ${getActiveClass(5, "active")}`} id="Informatie">
                        <h1 className="sidebar-header">
                            Informatie venster
                            <span className="sidebar-close" onClick={() => closeSidebar()}>
                                <i className="fa fa-caret-left"></i>
                            </span>
                        </h1>
                        <p>
                            Door het selecteren (klik) van een perceelpunt wordt de legger informatie van het perceel in
                            het Informatie venster getoond.
                        </p>
                        <p>Gebruik in het venster de volgende knoppen :</p>
                        <p>
                            <span className="mybtn">
                                <i className="fa-solid fa-eye"></i>
                            </span>
                            Toon de filiatie op Bonmama.nl
                        </p>
                        <p>
                            <span className="mybtn">
                                <i className="fa-regular fa-map"></i>
                            </span>
                            Toon (hulp)kaart
                        </p>
                        <p>
                            <span className="mybtn">
                                <i className="fa-solid fa-trash-can"></i>
                            </span>
                            Verberg hulpkaart
                        </p>
                        <p>
                            <span className="mybtn">
                                <i className="fa-solid fa-arrow-right-arrow-left"></i>
                            </span>
                            Ga naar perceel
                        </p>

                        <p>
                            Navigatie in het informatie venster geeft geen invloed op de kaart, gebruik daarvoor de
                            knppen.
                        </p>
                    </div>
                </div>
            </div>
            <Controls leftPanelOpen={LeftPanelOpen} />
        </div>
    );
};
